import { render, staticRenderFns } from "./Experience.vue?vue&type=template&id=49a2b0bb&scoped=true&"
import script from "./Experience.vue?vue&type=script&lang=ts&"
export * from "./Experience.vue?vue&type=script&lang=ts&"
import style0 from "./Experience.vue?vue&type=style&index=0&id=49a2b0bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a2b0bb",
  null
  
)

export default component.exports